internalStateGetterFor